import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as React from 'react'
import FileUploader from 'react-firebase-file-uploader'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import logo from 'src/images/common/brand/avatar.svg'
import { dispatch, RootState, select, store } from '../../store'
import styles from './avatar.scss'


const cx = classnames.bind(styles)

interface IProps extends React.HTMLProps<HTMLDivElement> {
  editable?: boolean
  userId?: string
  fluid?: boolean
}
class Avatar extends React.PureComponent<IProps> {
  public state = {
    error: null
  }
  public fetchData = (props: IProps) => {
    const rootState = store.getState()
    const { userId } = props
    const user = select.users.getById(rootState, userId)
    if (userId && user === null) {
      dispatch.users.fetchUsers([userId])
    }
  }
  public handleUploadSuccess = async (filename: string) => {
    const { userId } = this.props
    const currentUser = firebase.auth().currentUser
    if (userId === undefined || currentUser === null || currentUser.uid !== userId) {
      throw Error('no user to upload photo')
    }
    const ref = firebase.storage().ref(userId).child(filename)
    const downloadUrl = await ref.getDownloadURL()
    currentUser.updateProfile({
      displayName: currentUser.displayName,
      photoURL: downloadUrl,
    })
      .then(_ => dispatch.auth.updateUser(currentUser))
      .catch(error => this.setState({ error }))
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    if (nextProps.userId !== this.props.userId) {
      this.fetchData(nextProps)
    }
  }
  public componentDidMount = () => {
    this.fetchData(this.props)
  }
  public render() {
    const { fluid, className, userId, readOnly, editable } = this.props
    const rootState = store.getState()
    const user = select.users.getById(rootState, userId)
    const style = {
      backgroundImage: user && user.photoURL ? `url('${user.photoURL}')` : `url('${logo}')`
    }
    if (userId && editable) {
      return (
        <label className={cx('avatar', { fluid, editable }, className)} style={style}>
          <FileUploader
            hidden={true}
            randomizeFilename={true}
            accept="image/*"
            storageRef={firebase.storage().ref(userId)}
            onUploadSuccess={this.handleUploadSuccess}
          />
        </label>
      )
    }
    return !readOnly && userId ? (
      <Link to={`/users/${userId}`} className={cx('avatar', { fluid }, className)} style={style} />
    ) : (
        <div className={cx('avatar', { fluid }, className)} style={style} />
      )
  }
}

const mapState = ({ users }: RootState) => ({ users })
export default connect(mapState)(Avatar)



// WEBPACK FOOTER //
// ./src/components/Avatar/index.tsx